module.exports = __webpack_public_path__ + "static/media/sofom-login.6655899e.jpg";